import { createContext, useEffect, useState, ReactElement } from "react";

// third-party
import { Chance } from "chance";
// import jwtDecode from 'jwt-decode';

// reducer - state management
// import { LOGIN, LOGOUT } from 'store/reducers/actions';
// import authReducer from 'store/reducers/auth';

// project-imports
import Loader from "components/Loader";
import axios from "utils/axios";
// import { KeyedObject } from 'types/root';
import { JWTContextType } from "types/auth";

const chance = new Chance();

// constant
// const initialState: AuthProps = {
//   isLoggedIn: false,
//   isInitialized: false,
//   user: null
// };

// const verifyToken: (st: string) => boolean = (serviceToken) => {
//   if (!serviceToken) {
//     return false;
//   }
//   const decoded: KeyedObject = jwtDecode(serviceToken);

//   /**
//    * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
//    */
//   return decoded.exp > Date.now() / 1000;
// };

const setSession = (serviceToken?: string | null) => {
  if (serviceToken) {
    sessionStorage.setItem("serviceToken", serviceToken);
    axios.defaults.headers.common.Authorization = `Bearer ${serviceToken}`;
  } else {
    sessionStorage.removeItem("serviceToken");
    delete axios.defaults.headers.common.Authorization;
  }
};

// ==============================|| JWT CONTEXT & PROVIDER ||============================== //

const JWTContext = createContext<JWTContextType | null>(null);

export const JWTProvider = ({ children }: { children: ReactElement }) => {
  const [state, setLocalState] = useState({
    usuario: "",
    rol: "",
    transportista_: 0,
    transportista: () => {
      if (sessionStorage.getItem("transportista") !== null) {
        const Value = sessionStorage.getItem("transportista");
        return Value;
      }
      return 0;
    },
    aduana: "",
    aduanaInfo: "",
    op1: null, // Dato para el manifiesto en busqueda
    op2: "",

    isInitialized: true,
    isLoggedIn: () => {
      // let SM = sessionStorage.getItem('SM')
      if (sessionStorage.getItem("SM") !== null) {
        const Value = sessionStorage.getItem("isLoggedIn");
        return Value;
      }
      return false;
    }

    //false
  });

  const newValue = sessionStorage.getItem("transportista");
  if (newValue !== null && newValue !== "0" && newValue !== "" && state.transportista_ === 0) {
    setLocalState((prevstate) => ({
      ...prevstate,
      transportista_: Number(sessionStorage.getItem('transportista'))
    }));
  }
  // alert('Ejemplo');
  const SetTripnum = (arg: any) => {
    setLocalState((prevstate) => ({
      ...prevstate,
      op1: arg.TripNum
    }));
  };
  const SetTrasnportistaForMadulo = (arg: any) => {
    setLocalState((prevstate) => ({
      ...prevstate,
      transportista_: arg.transportista
    }));
    sessionStorage.setItem("transportista", JSON.stringify(arg.transportista));
    sessionStorage.setItem("transportistaRazonSocial", arg.RazonSocial);
  };
  const SetReloadCreditos = () => {
    const randomValue = chance.string({ length: 10 });
    setLocalState((prevstate) => ({
      ...prevstate,
      op2: randomValue
    }));
  };
  const SetDatosLogin = (arg: any) => {
    sessionStorage.setItem("objtransportista", JSON.stringify({}));
    sessionStorage.setItem("usuario", arg.usuario);
    sessionStorage.setItem("rol", arg.rol);
    sessionStorage.setItem("transportista", JSON.stringify(arg.transportista));
    sessionStorage.setItem("aduana", arg.aduana);
    sessionStorage.setItem("aduanainfo", arg.aduana);
    sessionStorage.setItem("transportistaRazonSocial", arg.RazonSocial);
    sessionStorage.setItem("Creditos", arg.Creditos);
    sessionStorage.setItem("scac", arg.scac);
    sessionStorage.setItem("isLoggedIn", JSON.stringify(true));
    setLocalState((prevstate) => ({
      ...prevstate,
      usuario: arg.usuario,
      rol: arg.rol,
      transportista: arg.transportista,
      aduana: arg.aduana,
      isInitialized: true
      // isLoggedIn:true
    }));
  };
  const [Load, setLoad] = useState(false);

  const Dloanding = () => {
    setLoad(false);
  };
  const loanding = () => {
    setLoad(true);
  };
  useEffect(() => {
    sessionStorage.setItem("SM", JSON.stringify(state));
  }, [state]);

  const login = async (email: string, password: string) => {
    // const response = await axios.post('/api/account/login', { email, password });
    // const { serviceToken, user } = response.data;
    // setSession(serviceToken);
    // dispatch({
    //   type: LOGIN,
    //   payload: {
    //     isLoggedIn: true,
    //     user
    //   }
    // });
  };

  const register = async (
    email: string,
    password: string,
    firstName: string,
    lastName: string
  ) => {
    // todo: this flow need to be recode as it not verified
    const id = chance.bb_pin();
    const response = await axios.post("/api/account/register", {
      id,
      email,
      password,
      firstName,
      lastName
    });
    let users = response.data;

    if (
      window.sessionStorage.getItem("users") !== undefined &&
      window.sessionStorage.getItem("users") !== null
    ) {
      const localUsers = window.sessionStorage.getItem("users");
      users = [
        ...JSON.parse(localUsers!),
        {
          id,
          email,
          password,
          name: `${firstName} ${lastName}`
        }
      ];
    }

    window.sessionStorage.setItem("users", JSON.stringify(users));
  };


  const logout = () => {
    setSession(null);
    // dispatch({ type: LOGOUT });
  };

  const resetPassword = async (email: string) => {};

  const updateProfile = () => {
    
  };

  const setTransportistaInfo = (arg:any) => {
    setLocalState((prevstate) => ({
      ...prevstate,
      aduanaInfo: arg.aduana
    }));
  }
  if (state.isInitialized !== undefined && !state.isInitialized) {
    return <Loader />;
  }

  return (
    <JWTContext.Provider
      value={{
        ...state,
        state,
        setLocalState,
        SetTripnum,
        SetTrasnportistaForMadulo,
        login,
        logout,
        register,
        resetPassword,
        updateProfile,
        Load,
        loanding,
        Dloanding,
        SetDatosLogin,
        setTransportistaInfo,
        SetReloadCreditos
      }}
    >
      {children}
    </JWTContext.Provider>
  );
};

export default JWTContext;
